export const SET_SHOW_LOGO = 'SET_SHOW_LOGO';
export const SET_SHOW_ARTWORK_DETAILS = 'SET_SHOW_ARTWORK_DETAILS';
export const SET_SWITCH_ARTWORK = 'SET_SWITCH_ARTWORK';
export const SET_4K_QUALITY = 'SET_4K_QUALITY';
export const SET_MUTE = 'SET_MUTE';
export const QR = 'QR';
export const MATCHCONTENT = 'MATCHCONTENT';
export const FILL_SCREEN = 'FILL_SCREEN';
export const RANDOMISE = 'RANDOMISE';
